﻿import type { SipClient, InitOptions } from "./api";
import { NoopClient } from "./clients/noopClient";
import { RealSipClient } from "./clients/realSipClient";

export function createClient(opts: {
    mock: boolean;
    init?: InitOptions;
}): SipClient {
    let client: SipClient;

    if (opts.mock) {
        console.info("[ETS] createClient → NoopClient (mock)");
        client = new NoopClient();
    } else {
        console.info("[ETS] createClient → RealSipClient");
        client = new RealSipClient();
    }
        
    if (opts.init) {
        client.init(opts.init);
    }
    return client;

}
